import {Component, OnInit, ViewChild} from '@angular/core';
import {FileItem} from 'ng2-file-upload';
import {
  AbstractFieldInputTypeHandlerComponent,
  FormValueReadableValue
} from '../../type-handler/abstract-field-input-type-handler.component';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {FileUploadComponent} from '../../../../file-upload/file-upload.component';
import {FormDefinitionFieldModel} from '../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model';
import {FormValueModel} from '../../../../../../modules/form/form/value/api/entity/formValue.model';
import {DocumentSummaryModel} from '../../../../../../modules/document/common/api/model/documentSummary.model';
import {
  FormFieldDefinitionOptionModel
} from "../../../../../../modules/form/definition/field/api/entity/formFieldDefinitionOption.model";
@Component({
  selector: 'app-document-pdf-field-input-type-handler',
  templateUrl: './document-pdf-field-input-type-handler.component.html',
})
export class DocumentPdfFieldInputTypeHandlerComponent extends AbstractFieldInputTypeHandlerComponent<UntypedFormControl>
    implements OnInit {

  document: DocumentSummaryModel;
  @ViewChild('fileUpload') fileUploadComponent: FileUploadComponent;

  constructor(private formBuilder: UntypedFormBuilder) {
    super();
  }

  public static resolveReadableValues(value: any,
                                      unit: string,
                                      options: FormFieldDefinitionOptionModel[]): Promise<FormValueReadableValue[]> {
    return Promise.resolve([
      FormValueReadableValue.ofDocument(value)
    ]);
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): UntypedFormControl {
    return this.formBuilder.control('value', formDefinitionField.required ? Validators.required : []);
  }

  initiateForm(formValue: FormValueModel): void {
    console.log(['initiate form', formValue]);
    this.jsonControl.setValue(formValue?.document?.id);
    this.document = formValue?.document;
  }

  synchronizeValue(): string {
    return this.jsonControl.value;
  }

  reset() {
    this.document = undefined;
    this.jsonControl.reset();
  }

  onFileAdded(fileItem: FileItem) {
    if (fileItem) {
      this.setMeasured(true);
      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        const base64 = btoa(event.target.result.toString());
        this.jsonControl.setValue(base64);
      };
      fileReader.readAsBinaryString(fileItem._file);
      this.fileUploadComponent.reset();
    }
  }



}
